import { consumerGroupIsNotStudentOrGraduate } from '@src/helpers'

export function canRenderPlaceholder(props, state) {
  return props.placeholder && !state.focused && !props.value
}

export function canRenderError(props) {
  return !!props.error
}

export function canRenderHint(props, state) {
  return props.hint && !props.error && state.focused
}

export function getLabelId(id) {
  return `label-${id}`
}

export const shouldRenderEmailHint = (consumerGroup, isVerification) => {
  return !consumerGroupIsNotStudentOrGraduate(consumerGroup) && isVerification
}
